// ui/landingPage/samplingEventsTab/state.js

import { SAMPLING_EVENT_VIEWS } from "../../../../constants/samplingEventConstants";

export const samplingEventsTabUIInitialState = {
  currentView: SAMPLING_EVENT_VIEWS.TABLE,
  activeTab: "active", // 'active' | 'completed' | 'well uploads'
};
